import React, { FC } from "react";
import { SkeletonBase } from "@foris/avocado-suite";
import styles from "./reportsList.module.scss";

interface CatalogsSkeletonProps {
  items: any[];
}

const ReportsListSkeleton: FC<CatalogsSkeletonProps> = ({ items }) => {
  return (
    <div className={styles.reportsSkeleton}>
      <SkeletonBase maxWidth={"100%"} height={24} />
      <SkeletonBase className={styles.reportsSkeleton_search} maxWidth={269} height={36} />
      <div className={styles.reportsSkeleton_filter}>
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
        <SkeletonBase maxWidth={"130px"} height={30} />
      </div>
      <div className={styles.reportsSkeleton_cards}>
        {items.map((_, _index) => {
          return (
            <div className={styles.card} key={_index}>
              <SkeletonBase maxWidth={"100%"} height={22} />
              <SkeletonBase maxWidth={"100%"} height={61} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReportsListSkeleton;
